<div class="model-reg-beackdrop" *ngIf="regProgress">
  <div class="svg-loader"></div>
</div>
<form (ngSubmit)="onSubmit()" #f="ngForm">
  <div class="progressRibbon">
    <button type="button" class="close cancelBtn" typeof="button" aria-label="Close" mat-dialog-close>
      Close
    </button>
    <div class="mod-stepper-container">
      <div class="mod-stepper">
        <div class="stepper-cricle"
             [ngClass]="{ 'active-stepper': selectedStep === 0}">
          <div class="stepper-header">Select Model</div>
          <div class="stepper-number">1</div>
        </div>
        <div class="stepper-bar"></div>
        <div class="stepper-cricle"
             [ngClass]="{ 'active-stepper': selectedStep === 1}">
          <div class="stepper-header">
            Configure UI Preferences
          </div>
          <div class="stepper-number">2</div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!isVertical">
    <mat-horizontal-stepper (selectionChange)="stepChange($event)" labelPosition="bottom" [linear]="isLinear" (animationDone)="selectionChange(stepper.selectedIndex )" #stepper>
      <mat-step [stepControl]="firstFormGroup" label="Select Model">
        <ng-template matStepLabel>Select Model</ng-template>
        <div class="float-right text-right d-flex">
          <button class="btn font-weight-bold nextBtn" [disabled]="validateFirstStep()" matStepperNext type="button">
            <mat-icon class="mat-icon-arrow">keyboard_arrow_right</mat-icon>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="step1Template"></ng-container>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup" label="configuration">
        <ng-template matStepLabel>Configure UI Preferences</ng-template>
        <div class="float-right text-right d-flex">
          <div>
            <button class="btn font-weight-bold prevBtn" matStepperPrevious>
              <mat-icon class="mat-icon-arrow">keyboard_arrow_left</mat-icon>
            </button>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="step2Template"></ng-container>
        <div class="stepperFooter clear d-flex justify-content-end">
          <button type="button" class="btn btn-primary" typeof="button" aria-label="Save" (click)="onSubmit()"
            [ngClass]="{ 'd-none': data.modelAction === 'viewModel'}"
            [disabled]="checkValidParam() || captionExist || invalidModelAndVersion || invalidStepTwo || isUOMDisabled || checkUOMTypeChanged">
            Save
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>

  </ng-container>
  <ng-container *ngIf="isVertical">
    <mat-vertical-stepper [linear]="isLinear" #stepper>
      <mat-step [stepControl]="firstFormGroup">
        <ng-template matStepLabel>Select Model</ng-template>
        <ng-container *ngTemplateOutlet="step1Template"></ng-container>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup">
        <ng-template matStepLabel>Configure UI Preferences</ng-template>
        <ng-container *ngTemplateOutlet="step2Template"></ng-container>
      </mat-step>
    </mat-vertical-stepper>
  </ng-container>
  <ng-template #step1Template>
    <div class="modelRegistration">
      <div class="stepTwo">
        <div class="modelRegistrationPage">
          <div class="modelTypeContinaer">
            <div class="modelType arrow"
                 [ngClass]="{ 'activeModel': activModelName === 'Physics Based'}"
                 (click)="isPhysicsDisabled && selectModelType('Physics Based')"
                 (keydown)="isPhysicsDisabled && selectModelType('Physics Based');">
              Physics Based
            </div>
            <div class="modelType arrow"
                 [ngClass]="{ 'activeModel': activModelName === 'Advanced Analytics'}"
                 (click)="isAdvanceDisabled && selectModelType('Advanced Analytics')"
                 (keydown)="isAdvanceDisabled && selectModelType('Advanced Analytics');">
              Advanced Analytics
            </div>
          </div>
          <div class="availModelContainer">
            <div class="registrationFormGroup">
              <div class="form-group row">
                <label for="availalbleModel" class="col-sm-4 col-form-label">Model<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-8">
                  <select class="custom-select form-control" id="availalbleModel" (change)="onModelSelected(availalbleModel)"
                          [(ngModel)]="availalbleModel"
                          name="availalbleModel"
                          required
                          [ngClass]="{ 'readOnly': data.selectedData}">
                    <option *ngFor="let item of modelListOptions" [ngValue]="item">{{item.registrationName}}</option>
                  </select>
                  <div class="invalid-entry" *ngIf="availModelErro">{{availModelErro}}</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="availalbleModelVersion" class="col-sm-4 col-form-label">Model Version<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-8">
                  <select class="custom-select form-control" id="availalbleModelVersion" (change)="onVersionSelected(availalbleModelVersion)"
                          [(ngModel)]="availalbleModelVersion"
                          name="availalbleModelVersion"
                          required
                          [ngClass]="{ 'readOnly': data.selectedData}">
                    <option *ngFor="let item of availModelVersionList" [ngValue]="item">{{item.modelVersion}}</option>
                  </select>
                  <div class="invalid-entry" *ngIf="availModelErro">{{availModelErro}}</div>
                  <div class="invalid-entry" *ngIf="invalidModelAndVersion">This Model is already in use.</div>
                </div>
              </div>

              <div class="form-group row" *ngIf="isPhysicsBasedType">
                <label for="physicsBasedType" class="col-sm-4 col-form-label">Base Model</label>
                <div class="col-sm-8">
                  <select class="custom-select form-control" id="physicsBasedType"
                          [(ngModel)]="physicsBasedType"
                          name="physicsBasedType"
                          required disabled
                          [ngClass]="{ 'readOnly': data.selectedData}">
                    <option selected *ngFor="let item of baseModelTypesList" [ngValue]="item">{{item.baseModelName}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label for="registrationName" class="col-sm-4 col-form-label">Display Name<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-8">
                  <input disabled type="text" class="form-control" id="registrationName"
                         [(ngModel)]="registrationName"
                         name="name"
                         #name="ngModel"
                         maxlength="61"
                         pattern="^[A-Za-z0-9][A-Za-z0-9_.-]*"
                         required
                         (focus)="resetNameValid()"
                         (focusout)="chkNameValid()"
                         [readonly]="data.selectedData">
                  <div *ngIf="regErrorMsg" class="invalid-entry">
                    The name of a model must be only letters, numbers, dashes, periods, or underscores, and start with a letter or number
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="description" class="col-sm-4 col-form-label">Description<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-8">
                  <textarea class="form-control" id="description"
                            [(ngModel)]="description"
                            name="description"
                            maxlength="100"
                            required
                            [readonly]="data.selectedData"></textarea>
                </div>
              </div>
              <div class="form-group row">
                <label for="businessFunction" class="col-sm-4 col-form-label">Business Function<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-8">
                  <select class="custom-select form-control" id="businessFunction"
                          [(ngModel)]="businessFunction"
                          name="businessFunction"
                          required
                          [ngClass]="{ 'readOnly': data.selectedData}">
                    <option *ngFor="let item of businessFunctionTypesList" [ngValue]="item">{{item.businessFunctionTypeName}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label for="modelImage" class="col-sm-4 col-form-label">Model Image</label>
                <div class="col-sm-8">
                  <div>
                    <input hidden id="modelImage"
                           type="file"
                           [multiple]="false"
                           #imageUploader
                           (change)="handleModelImageInput($event.target.files[0])"
                           accept=".svg" />
                  </div>
                  <div class="input-group-text inputCustomised" [ngClass]="{ 'readOnly': data.modelAction === 'viewModel'}">
                    <span *ngIf="!selectedImageName"> No File Selected</span>
                    <span *ngIf="selectedImageName"> {{selectedImageName}}</span>
                    <div (click)="imageUploader.click()" (keydown)="imageUploader.click();" class="uploadModelFile pointer" [ngClass]="{ 'd-none': data.modelAction === 'viewModel'}">
                      <img src="../../../assets/Images/upload_new.svg" alt="uploadIcon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </ng-template>
  <ng-template #step2Template>
    <div class="modelRegistration">
      <div class="stepTwo">
        <div class="modelRegistrationPage configureParam" *ngIf="!regProgress && modelData.inputParameters.length > 0">
          <div class="modelTypeContinaer">
            <div class="modelType"
                 [ngClass]="{ 'activeModel': isInputParameters}"
                 (click)="selectParamType('input', true)"
                 (keydown)="selectParamType('input', true);">
              <div class="parameterType">Input Parameters</div>
            </div>
            <div class="modelType"
                 [ngClass]="{ 'activeModel': !isInputParameters}"
                 (click)="selectParamType('output', false)"
                 (keydown)="selectParamType('output', false);">
              <div class="parameterType">Output Parameters</div>
            </div>
          </div>
          <div class="paramsContainer">
            <div class="paramsList" *ngIf="isInputParameters">
              <div class="listParamsContainer">
                <div class="paramsName" *ngFor="let items of modelData.inputParameters; let $index=index;" 
                (click)="configureIt(modelData.inputParameters[$index].uomType, $index)" 
                (keydown)="configureIt(modelData.inputParameters[$index].uomType, $index);"
                [ngClass]="activeParam === $index ? 'activeSubClass' : '' ">
                  <mat-icon class="green-icon float-left" *ngIf="items.captionName && items.uomType && items.parameterUom && !dupCapInParam[$index]" 
                  (click)="resetThisParams(modelData.inputParameters, $index)" (keydown)="resetThisParams(modelData.inputParameters, $index);">check_circle</mat-icon>
                  <mat-icon class="unselectedCircle float-left" *ngIf="(!items.captionName || !items.uomType || !items.parameterUom || dupCapInParam[$index]) && activeParam === $index">stop_circle</mat-icon>
                  <mat-icon class="transperentCircle float-left" *ngIf="(!items.captionName || !items.uomType || !items.parameterUom || dupCapInParam[$index]) && activeParam !== $index">stop_circle</mat-icon>
                  <span class="paramLabel">{{items.parameterName}}</span>
                </div>
              </div>
            </div>
            <div class="paramsList" *ngIf="!isInputParameters">
              <div class="listParamsContainer">
                <div class="paramsName" *ngFor="let items of modelData.outputParameters; let $index=index;" 
                (click)="configureIt(modelData.outputParameters[$index].uomType, $index)"
                (keydown)="configureIt(modelData.outputParameters[$index].uomType, $index);"
                [ngClass]="activeParam === $index ? 'activeSubClass' : '' ">
                  <mat-icon class="green-icon float-left" *ngIf="items.captionName && items.parameterUom && !dupCapOutParam[$index]" 
                  (click)="resetThisParams(modelData.outputParameters, $index)" (keydown)="resetThisParams(modelData.outputParameters, $index);">check_circle</mat-icon>
                  <mat-icon class="unselectedCircle float-left" *ngIf="(!items.captionName || !items.parameterUom || dupCapOutParam[$index]) && activeParam === $index">stop_circle</mat-icon>
                  <mat-icon class="transperentCircle float-left" *ngIf="(!items.captionName || !items.parameterUom || dupCapOutParam[$index]) && activeParam !== $index">stop_circle</mat-icon>
                  <span class="paramLabel">{{items.parameterName}}</span>
                </div>
              </div>
            </div>
            <div class="paramsConfigOptions">
              <div class="form-group row">
                <label for="inputCaption" class="col-sm-5 col-form-label">Display Name<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-7" *ngIf="isInputParameters">
                  <input type="text" class="form-control" id="inputCaption"
                         [(ngModel)]="modelData.inputParameters[activeParam].captionName"
                         name="captionnameIn"
                         #captionnameIn="ngModel"
                         maxlength="30"
                         (keyup)="validateCaption($event, activeParam, dupCapInParam, validCapInParam, modelData.inputParameters)"
                         autofocus
                         required
                         [ngClass]="{ 'readOnly': data.modelAction === 'viewModel'}">
                  <div *ngIf="dupCapInParam[activeParam]" class="invalid-entry">
                    This name is already set!
                  </div>
                  <div *ngIf="validCapInParam[activeParam]" class="invalid-entry">
                    The name of a caption must be only letters, numbers, dashes, periods, or underscores, and start with a letter or number
                  </div>
                </div>
                <div class="col-sm-7" *ngIf="!isInputParameters">
                  <input type="text" class="form-control" id="inputCaption"
                         [(ngModel)]="modelData.outputParameters[activeParam].captionName"
                         name="captionnameIn"
                         #captionnameIn="ngModel"
                         maxlength="30"
                         (keyup)="validateCaption($event, activeParam, dupCapOutParam, validCapOutParam, modelData.outputParameters)"
                         required
                         [ngClass]="{ 'readOnly': data.modelAction === 'viewModel'}">
                  <div *ngIf="dupCapOutParam[activeParam]" class="invalid-entry">
                    This name is already set!
                  </div>
                  <div *ngIf="validCapOutParam[activeParam]" class="invalid-entry">
                    The name of a caption must be only letters, numbers, dashes, periods, or underscores, and start with a letter or number
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="unit" class="col-sm-5 col-form-label">UOM Type<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-7" *ngIf="isInputParameters">
                  <select class="form-control form-control-sm inlineControl uomTDropdown" name="modelData.inputParameters[activeParam].uomType"
                          [(ngModel)]="modelData.inputParameters[activeParam].uomType"
                          (change)="populateUOM(modelData.inputParameters[activeParam].uomType); resetUOM(activeParam,'inputParameters')" required
                          [ngClass]="{ 'readOnly': data.modelAction === 'viewModel'}">
                    <option [ngValue]="selected" selected disabled>--Select--</option>
                    <option *ngFor="let uomType of uomTypes" [ngValue]="uomType">{{uomType}}</option>
                  </select>
                </div>
                <div class="col-sm-7" *ngIf="!isInputParameters">
                  <select class="form-control form-control-sm inlineControl uomTDropdown" name="modelData.outputParameters[activeParam].uomType"
                          [(ngModel)]="modelData.outputParameters[activeParam].uomType"
                          (change)="populateUOM(modelData.outputParameters[activeParam].uomType); resetUOM(activeParam,'outputParameters')" required
                          [ngClass]="{ 'readOnly': data.modelAction === 'viewModel'}">
                    <option [ngValue]="selected" selected disabled>--Select--</option>
                    <option *ngFor="let uomType of uomTypes" [ngValue]="uomType">{{uomType}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row" *ngIf="isInputParameters && modelData.inputParameters[activeParam].uomType">
                <label class="col-sm-5 col-form-label" *ngIf="modelData.inputParameters[activeParam].uomType" for="unit">UOM<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-7" *ngIf="modelData.inputParameters[activeParam].uomType">
                  <select *ngIf="modelData.inputParameters[activeParam].uomType" class="form-control form-control-sm inlineControl" name="uomname{{i}}"
                          [ngModel]="modelData.inputParameters[activeParam].parameterUom"
                          (ngModelChange)="resetUOMType(activeParam, $event,'inputParameters')" required
                          [ngClass]="{ 'readOnly': data.modelAction === 'viewModel'}">
                    <option disabled value="">--Select--</option>
                    <option *ngFor="let uom of uoms" [ngValue]="uom">{{uom}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row" *ngIf="!isInputParameters && modelData.outputParameters[activeParam].uomType">
                <label class="col-sm-5 col-form-label" *ngIf="modelData.outputParameters[activeParam].uomType" for="unit">UOM<span class="text-danger star-danger">*</span></label>
                <div class="col-sm-7" *ngIf="modelData.outputParameters[activeParam].uomType">
                  <select *ngIf="modelData.outputParameters[activeParam].uomType" class="form-control form-control-sm inlineControl" name="uomname{{i}}"
                          [ngModel]="modelData.outputParameters[activeParam].parameterUom"
                          (ngModelChange)="resetUOMType(activeParam, $event, 'outputParameters')" required
                          [ngClass]="{ 'readOnly': data.modelAction === 'viewModel'}">
                    <option disabled value="">--Select--</option>
                    <option *ngFor="let uom of uoms" [ngValue]="uom">{{uom}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="noInputOutputParam" *ngIf="!regProgress && modelData.inputParameters.length === 0">
          {{noInputOutputParam}}
        </div>
        <div class="noInputOutputParam" *ngIf="!regProgress && modelParamsErro">
          {{modelParamsErro}}
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #step3Template>
    <div class="lastStep modelRegistration">
      <div class="stepThree">
        <div class="modelRegistrationPage">
          <div class="registrationFormGroup">
            <div class="modelDetail">
              <div class="row mb-3">
                <div class="col-sm-5">Model Name:</div>
                <div class="col-sm-7">{{registrationName}}</div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-5">Type:</div>
                <div class="col-sm-7">{{activModelName}}</div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-5">Business Function:</div>
                <div class="col-sm-7">{{businessFunction.businessFunctionTypeName}}</div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-5">Description:</div>
                <div class="col-sm-7">{{description}}</div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-5">Model:</div>
                <div class="col-sm-7">{{availalbleModel.properties.displayName}}</div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-5">Model Image:</div>
                <div class="col-sm-7">{{selectedImageName}}</div>
              </div>
              <div *ngIf="errorInModelCreation" class="invalid-entry">
                {{errorInModelCreation}}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </ng-template>

</form>
